import { SlateStatus } from '@betterpool/api-types/games-service';

import type { ContestSlate } from '../interfaces/contest.slates.interface';
import type { Slate } from '../interfaces/slates.interface';

export const findDefaultSlate = <S extends Slate | ContestSlate>(
  slates: S[],
  includeScheduled?: boolean
): S => {
  if (!slates) return null;

  const inProgressStatuses = [
    SlateStatus.LIVE,
    SlateStatus.IN_PROGRESS,
    SlateStatus.FINISHED,
    includeScheduled && SlateStatus.SCHEDULED,
  ].filter(Boolean);
  let defaultSlate = slates?.find((slate) => inProgressStatuses.includes(slate.status));

  if (!defaultSlate) {
    defaultSlate = slates?.findLast((slate) => slate.status === SlateStatus.SETTLED);
  }

  return defaultSlate ?? slates?.[0] ?? null;
};
